import { isNotNil } from "ramda-adjunct";
import { RateBuilderTreeViewItem } from "@sinch/components/application/RatelistBuilder/types";

interface TreeNode {
  id: string;
  conditionFailureNode: string | null;
  conditionSuccessNodes: string[];
}

export const treeToRatelistNode = (tree: RateBuilderTreeViewItem[], isIfElse = false): TreeNode[] =>
  tree.reduce<TreeNode[]>((acc, node, ix) => {
    const newItems = [...acc];
    const newNode: TreeNode = { id: node.id, conditionFailureNode: null, conditionSuccessNodes: [] as string[] };
    const isWrapper = node.type === "wrapper";
    if (!isWrapper) {
      newItems.push(newNode);
    }
    if (isIfElse) {
      newNode.conditionFailureNode = tree[ix + 1]?.id ?? null;
    }
    if (node.children) {
      newNode.conditionSuccessNodes = getChildrenIds(node.children);
      const children = treeToRatelistNode(node.children, isWrapper);
      return [...newItems, ...children];
    }
    return newItems;
  }, []);

const getChildrenIds = (childrenList: RateBuilderTreeViewItem[]): string[] =>
  childrenList
    .map(({ id, type, children }) => {
      if (type !== "wrapper") {
        return id;
      }
      if (children) {
        return getChildrenIds(children)[0];
      }
      return null;
    })
    .filter((element) => isNotNil(element));
